import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2554967c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "userlist" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listname" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "iconfont icon-top_jibenxinxi i1",
      style: {"margin-right":"14px"}
    }),
    /*#__PURE__*/_createTextVNode("基本信息 ")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listname" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-yidongduanlianxi2 i1" }),
    /*#__PURE__*/_createTextVNode("作品中心 ")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listname" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-quanbudingdan1 i1" }),
    /*#__PURE__*/_createTextVNode("我的订单")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listname" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-wodezhanghu1 i1" }),
    /*#__PURE__*/_createTextVNode("我的账户")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listname" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-shoucang12 i1" }),
    /*#__PURE__*/_createTextVNode("我的收藏")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listname" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-lishijilu1 i1" }),
    /*#__PURE__*/_createTextVNode("我的足迹")
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listname" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-huiyuan1 i1" }),
    /*#__PURE__*/_createTextVNode("会员中心")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listname" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-youhuiquan11 i1" }),
    /*#__PURE__*/_createTextVNode("我的优惠券")
  ])
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listname" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-dizhiguanli i1" }),
    /*#__PURE__*/_createTextVNode("我的地址")
  ])
], -1))
const _hoisted_11 = { class: "listname" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-xiaoxi12 i1" }),
  /*#__PURE__*/_createTextVNode("我的消息")
], -1))
const _hoisted_13 = {
  key: 0,
  class: "number"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listname" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-shoucang12-1 i1" }),
    /*#__PURE__*/_createTextVNode("个人认证")
  ])
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listname" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-qiye1 i1" }),
    /*#__PURE__*/_createTextVNode("企业认证")
  ])
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listname" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-fapiaoguanli1 i1" }),
    /*#__PURE__*/_createTextVNode("发票服务")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { class: "tac" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu, {
              "default-active": _ctx.$route.path,
              router: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "/user/aside" }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/user/works" }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/user/myorder" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/user/myaccount" }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/user/project" }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/user/myfootmark" }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/user/myvip" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/user/discountcoupon" }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/user/mylocation" }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/user/mymessage" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      (_ctx.messageNumber > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.getInformation.data.pid == 0)
                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: 0,
                      index: "/user/selfverify"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.getInformation.data.pid == 0)
                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: 1,
                      index: "/user/firmverify"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_menu_item, { index: "/user/invoice" }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["default-active"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}